import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableRow,
  TextField,
  Typography,
  Grid,
  Box,
  FormGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { set, upperCase } from "lodash";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useAnnouncements } from "./AnnoucementsContext";
import {
  createAnnouncement,
  deleteAnnouncement,
  saveAnnouncement,
} from "./utils";
import QuillEditor from "react-quill";
import "react-quill/dist/quill.snow.css";
import imageResize from "quill-image-resize-module-react";
import Quill from "quill";
Quill.register("modules/imageResize", imageResize);

const AnnouncementForm = () => {
  const [open, setOpen] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [value, setValue] = useState("");
  const [preview, setPreview] = useState(false);
  const handlePreview = () => setPreview(!preview);

  const {
    announcement,
    filterValues,
    selectedAnnoucement,
    setSelectedAnnouncement,
    setReload,
    setAnnouncement,
    events,
    adminWebFiles,
    links,
    agencies,
    roadways,
    states,
    setStates,
    states2,
    setStates2,
    setRoadways,
    setAgencies,
    setEvents,
    setLinks,
    selectedEventBtn,
    selectedLinks,
    setSelectedLinks,
    setSelectedEventBtn,
    setAdminWebFiles,
    setSelectedLinkBtn,
  } = useAnnouncements();
  const quill = useRef();
  useEffect(() => {
    setOpen(selectedAnnoucement !== null || setAnnouncement !== null);
  }, [selectedAnnoucement, announcement]);

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const imageUrl = reader.result;
        const quillEditor = quill.current.getEditor();

        const range = quillEditor.getSelection(true);

        quillEditor.insertEmbed(range.index, "image", imageUrl, "user");
      };
      reader.readAsDataURL(file);
    };
  }, []);

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [2, 3, 4, false] }],
          ["bold", "italic", "underline", "blockquote"],
          [{ color: [] }],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize"],
      },
      clipboard: {
        matchVisual: true,
      },
    }),
    [imageHandler],
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "clean",
    "custom-image",
    "style",
    "width",
    "height",
  ];

  const handleChange = (e) => {
    const name = e.target.name.toLowerCase();
    const value = e.target.value;
    setAnnouncement((prev) => ({ ...prev, [name]: value }));
  };

  const handleEventBtn = (e) => {
    setSelectedEventBtn(true);
  };

  const handleLinkBtn = (e) => {
    setSelectedLinkBtn(true);
  };

  const formValidate = (selectedAnnoucement) => {
    let newFormErrors = {};
    let hasErrors = false;

    if (
      selectedAnnoucement.title === null ||
      selectedAnnoucement.title.trim() === ""
    ) {
      newFormErrors.title = "Please Enter title";
      // alert ("Title field should not be empty")
      hasErrors = true;
    }

    if (
      !selectedAnnoucement.newsItem &&
      !selectedAnnoucement.siteNews &&
      !selectedAnnoucement.construction &&
      !selectedAnnoucement.transit &&
      !selectedAnnoucement.weather &&
      !selectedAnnoucement.trucker
    ) {
      newFormErrors.type = "Select at least one type of announcement";
      // alert ("At least one of the following must be checked: newsItem, siteNews, construction, transit, weather, or trucker")
      hasErrors = true;
    }

    const exclusiveCategories = [
      selectedAnnoucement.siteNews,
      selectedAnnoucement.construction,
      selectedAnnoucement.transit,
      selectedAnnoucement.weather,
    ].filter(Boolean);

    if (exclusiveCategories.length > 1) {
      newFormErrors.type =
        "Only one of the following can be checked: siteNews, construction, transit, or weather";
      // alert("Only one of the following can be checked: siteNews, construction, transit, or weather")
      hasErrors = true;
    }

    if (
      selectedAnnoucement.state === null ||
      selectedAnnoucement.state === ""
    ) {
      newFormErrors.state = "Please select a state";
      // alert ("State field should not be empty")
      hasErrors = true;
    }

    if (selectedAnnoucement.link === null || selectedAnnoucement.link === "") {
      newFormErrors.link = "Please enter a link";
      // alert ("Link field should not be empty")
      hasErrors = true;
    }

    if (selectedAnnoucement.icon === null || selectedAnnoucement.icon === "") {
      newFormErrors.icon = "Please select icon ";
      // alert ("Icon field should not be empty")
      hasErrors = true;
    }

    if (
      selectedAnnoucement.html === null ||
      selectedAnnoucement.html.trim() === ""
    ) {
      newFormErrors.html = "Please Enter HTML content";
      alert("HTML content should not be empty");
      hasErrors = true;
    }

    if (selectedAnnoucement.link && selectedAnnoucement.link.trim() !== "") {
      if (!selectedAnnoucement.icon || selectedAnnoucement.icon.trim() === "") {
        newFormErrors.icon = "Icon is required when a link is provided";
        alert("Icon is required when a link is provided");
        hasErrors = true;
      }
    }

    setFormErrors(newFormErrors);
    return !hasErrors;
  };

  const saveAnnc = (selectedAnnoucement) => {
    const isValid = formValidate(selectedAnnoucement);

    if (!isValid) {
      return;
    }

    if (selectedAnnoucement.id === null) {
      createAnnouncement(selectedAnnoucement)
        .then(() => {
          setSelectedAnnouncement(null);
          setAnnouncement(null);
          setReload(true);
          setFormErrors({});
        })
        .catch((error) => {
          console.error("Error creating announcement:", error);
        });
    } else {
      saveAnnouncement(selectedAnnoucement)
        .then(() => {
          setSelectedAnnouncement(null);
          setAnnouncement(null);
          setReload(true);
          setFormErrors({});
        })
        .catch((error) => {
          console.error("Error saving announcement:", error);
        });
    }
  };

  const deleteAnnc = (selectedAnnoucement) => {
    deleteAnnouncement(selectedAnnoucement).then(() => {
      setSelectedAnnouncement(null);
      setAnnouncement(null);
      setReload(true);
    });
  };

  const onClose = (e, reason) => {
    setSelectedAnnouncement(null);
    setAnnouncement(null);
    // setEvents(null);
    setFormErrors({});
  };
  var title = "New Announcement";
  var eventIds = "";
  if (announcement) {
    if (announcement.id) title = "Edit Announcement";
    if (announcement.eventIds && announcement.eventIds.length > 0)
      eventIds = announcement.eventIds[0];
  }

  return (
    announcement && (
      <Dialog
        maxWidth="true"
        open={open}
        onClose={onClose}
        position="relative"
        fullWidth={true}
        fullScreen={true}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 20,
            top: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Card sx={{ borderRadius: 3, overflow: "auto" }}>
          <CardHeader
            title={<font className="layer-title"> {title} </font>}
            align="center"
            className={"styledtablerow"}
          />
          <DescriptionBlock />
          <CardContent
            sx={{
              paddingTop: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <Box
              component="form"
              size="small"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "30ch" },
                paddingTop: 3,
                align: "center",
              }}
            >
              <Grid
                container
                spacing={{ xs: 2 }}
                sx={{ justifyContent: "center" }}
              >
                <Grid>
                  <Table size="small">
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <TextField
                          disabled
                          size="small"
                          id="announcement-id"
                          label="ID"
                          value={announcement.id}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <TextField
                          fullWidth
                          disabled
                          size="small"
                          id="announcement-created-date"
                          label="Created Date"
                          value={announcement.creationDate}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <DateTimePicker
                          id="announcement-expiration-date"
                          label="Expiration Date"
                          value={announcement.expirationDate}
                          onChange={(newValue) => {
                            setAnnouncement((announcement) => {
                              return {
                                ...announcement,
                                expirationDate: newValue,
                              };
                            });
                          }}
                          renderInput={(params) => (
                            <TextField size="small" {...params} error={false} />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid>
                  <Table size="small">
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <TextField
                          size="small"
                          fullWidth
                          id="announcement-author"
                          label="Author"
                          name="author"
                          value={announcement.author}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <TextField
                          size="small"
                          id="announcement-high-prioritypageorder"
                          label="High Priority Page Order"
                          value={announcement.highPriorityPageOrder}
                          onChange={(e) => {
                            setAnnouncement((announcement) => {
                              return {
                                ...announcement,
                                highPriorityPageOrder: e.target.value,
                              };
                            });
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{ pt: 0, pl: 0 }}
                        className={"tablecellnoborder"}
                      >
                        <Autocomplete
                          freeSolo
                          options={filterValues.roadways || []}
                          value={announcement.roadway || ""}
                          onChange={(event, newValue) => {
                            setAnnouncement((prevAnnouncement) => ({
                              ...prevAnnouncement,
                              roadway: newValue || "",
                            }));
                          }}
                          onInputChange={(event, newInputValue) => {
                            setAnnouncement((prevAnnouncement) => ({
                              ...prevAnnouncement,
                              roadway: newInputValue || "",
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Roadway"
                              variant="outlined"
                              size="small"
                              placeholder="Select from list or type the input"
                            />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid>
                  <Table size="small">
                    <TableRow>
                      <TableCell
                        sx={{ pt: 1, pl: 1 }}
                        className={"tablecellnoborder"}
                      >
                        <FormControl fullWidth size="small" variant="outlined">
                          <InputLabel id="announcement-agency-label">
                            {" "}
                            State{" "}
                          </InputLabel>
                          <Select
                            required
                            labelId="announcement-State"
                            id="state-selection"
                            value={announcement.state}
                            label="State"
                            name="State"
                            onChange={handleChange}
                            error={formErrors.state}
                            helperText={formErrors.state}
                          >
                            {filterValues.states.map((eachState) => (
                              <MenuItem value={eachState} key={eachState}>
                                {eachState}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{ pt: 1, pl: 1 }}
                        className={"tablecellnoborder"}
                      >
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="announcement-agency-label">
                            {" "}
                            State2{" "}
                          </InputLabel>
                          <Select
                            labelId="announcement-State2"
                            id="state2-selection"
                            value={announcement.state2}
                            label="State2"
                            name="State2"
                            onChange={handleChange}
                          >
                            {filterValues.states.map((eachState) => (
                              <MenuItem value={eachState} key={eachState}>
                                {eachState}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{ pt: 1, pl: 1 }}
                        className={"tablecellnoborder"}
                      >
                        {announcement.eventIds &&
                          announcement.eventIds.length > 0 && (
                            <Typography>
                              {JSON.stringify(announcement.eventIds)}
                            </Typography>
                          )}
                        <Button
                          variant="outlined"
                          label="SelectEvents"
                          name="eventIds"
                          value={announcement.eventIds}
                          onClick={handleEventBtn}
                        >
                          {" "}
                          Select Events{" "}
                        </Button>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid>
                  <Table size="small">
                    <TableRow>
                      <TableCell
                        sx={{ pt: 1, pb: 0, pl: 1 }}
                        className={"tablecellnoborder"}
                      >
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="announcement-Icon-label">
                            {" "}
                            Icon{" "}
                          </InputLabel>
                          <Select
                            labelId="admin-web-files"
                            label="Icon"
                            id="Admin web files"
                            name="icon"
                            value={announcement.icon}
                            onChange={handleChange}
                            error={formErrors.icon}
                            helperText={formErrors.icon}
                          >
                            {adminWebFiles
                              .sort((a, b) => a.path.localeCompare(b.path))
                              .map((eachChild) => (
                                <MenuItem
                                  value={eachChild.path}
                                  key={upperCase(eachChild.id)}
                                >
                                  {eachChild.path}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{ pt: 1, pb: 0, pl: 0 }}
                        className={"tablecellnoborder"}
                      >
                        <TextField
                          size="small"
                          id="announcement-link"
                          label="Link"
                          type="link"
                          name="link"
                          value={announcement.link}
                          onChange={handleChange}
                          error={formErrors.link}
                          helperText={formErrors.link}
                        />
                        <Button
                          sx={{ marginTop: 1 }}
                          variant="outlined"
                          label="link"
                          name="link"
                          value={announcement.link}
                          onClick={handleLinkBtn}
                        >
                          {" "}
                          Select Link{" "}
                        </Button>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{ pt: 0, pl: 0 }}
                        className={"tablecellnoborder"}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "flex-start",
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Autocomplete
                              freeSolo
                              options={filterValues.agencies || []}
                              value={announcement.agency || ""}
                              onChange={(event, newValue) => {
                                setAnnouncement((prevAnnouncement) => ({
                                  ...prevAnnouncement,
                                  agency: newValue || "",
                                }));
                              }}
                              onInputChange={(event, newInputValue) => {
                                setAnnouncement((prevAnnouncement) => ({
                                  ...prevAnnouncement,
                                  agency: newInputValue || "",
                                }));
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Agency"
                                  variant="outlined"
                                  size="small"
                                  placeholder="Select from list or type the input"
                                />
                              )}
                            />
                          </Box>
                          <Box sx={{ flex: 1, pt: 1 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              fullWidth
                            >
                              <InputLabel id="message-Priority-label">
                                {" "}
                                Priority{" "}
                              </InputLabel>
                              <Select
                                labelId="announcementPriority-label"
                                id="priority-selection"
                                label="Priority"
                                value={announcement.priority}
                                onChange={handleChange}
                                name="Priority"
                              >
                                {filterValues.priorities.map((eachpriority) => (
                                  <MenuItem
                                    value={upperCase(eachpriority)}
                                    key={upperCase(eachpriority)}
                                  >
                                    {upperCase(eachpriority)}{" "}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid>
                  <Table size="small">
                    {formErrors.type && (
                      <TableRow>
                        <TableCell
                          className={"admin-tablecell tablecellnoborder"}
                          sx={{ paddingBottom: 1 }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "error.main", fontSize: "0.875rem" }}
                          >
                            {formErrors.type}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.highPriorityPage}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      highPriorityPage:
                                        !announcement.highPriorityPage,
                                    };
                                  });
                                }}
                              />
                            }
                            label="High Priority Page"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.newsItem}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      newsItem: !announcement.newsItem,
                                    };
                                  });
                                }}
                              />
                            }
                            label="News Item"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.siteNews}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      siteNews: !announcement.siteNews,
                                    };
                                  });
                                }}
                              />
                            }
                            label="Site News"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.construction}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      construction: !announcement.construction,
                                    };
                                  });
                                }}
                              />
                            }
                            label="Construction"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid>
                  <Table size="small">
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.transit}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      transit: !announcement.transit,
                                    };
                                  });
                                }}
                              />
                            }
                            label="Transit"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.weather}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      weather: !announcement.weather,
                                    };
                                  });
                                }}
                              />
                            }
                            label="Weather"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={"admin-tablecell tablecellnoborder"}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={announcement.trucker}
                                onChange={(e) => {
                                  setAnnouncement((announcement) => {
                                    return {
                                      ...announcement,
                                      trucker: !announcement.trucker,
                                    };
                                  });
                                }}
                              />
                            }
                            label="Trucker"
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <FormControl fullWidth>
                <TextField
                  multiline
                  sx={{ m: 2 }}
                  className={"tablecellnoborder"}
                  required
                  id="filled-title-flexible"
                  label="Title"
                  variant="filled"
                  name="title"
                  type="text"
                  error={formErrors.title}
                  helperText={formErrors.title}
                  value={announcement.title}
                  onChange={handleChange}
                />
              </FormControl>
            </Box>
            <Table>
              <TableRow>
                <QuillEditor
                  required
                  ref={(el) => (quill.current = el)}
                  className="editor"
                  theme="snow"
                  name="html"
                  value={announcement.html}
                  formats={formats}
                  modules={modules}
                  error={formErrors.html}
                  helperText={formErrors.html}
                  onChange={(value) =>
                    setAnnouncement((announcement) => {
                      return {
                        ...announcement,
                        html: value,
                      };
                    })
                  }
                />
              </TableRow>
              {preview && (
                <TableRow>
                  <TableCell
                    sx={{ m: 2, border: "1px solid grey", borderRadius: 2 }}
                  >
                    <div
                      className="preview-content"
                      dangerouslySetInnerHTML={{ __html: announcement.html }}
                    />
                  </TableCell>
                </TableRow>
              )}
            </Table>
            <Box gap={2} display="flex" sx={{ p: 2, justifyContent: "center" }}>
              <Button
                name="Html Preview"
                label="Html Preview"
                variant="outlined"
                size="small"
                onClick={handlePreview}
              >
                {preview ? "Hide Preview" : "Html Preview"}
              </Button>
              <Button
                name="Save Announcement"
                label="Save Announcement"
                variant="outlined"
                size="small"
                onClick={(e) => saveAnnc(announcement)}
              >
                Save Announcement
              </Button>
              <Button
                name="Delete Announcement"
                label="Delete Announcement"
                variant="outlined"
                size="small"
                onClick={(e) => deleteAnnc(announcement)}
              >
                Delete Announcement
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};

const DescriptionBlock = () => {
  const { openAdminWebFilesPage, setOpenAdminWebFilesPage } =
    useAnnouncements();
  return (
    <Typography
      fontSize={13}
      component="div"
      sx={{ padding: 2, textAlign: "left" }}
    >
      <ul>
        <li>
          A title and some text are required for the announcement, and an icon
          is required if there is a link.
        </li>
        <li>
          Enter the Expiration Date/Time in "mm/dd/yyyy hh:mm" format. For an
          announcement with no Expiration Date/Time, clear that field.
        </li>
        <li>
          With respect to announcement categories:
          <ul>
            <li>
              An announcement must have a category, and High Priority page
              cannot be the only category.
            </li>
            <li>
              An announcement cannot be more than one of Construction, Transit,
              and Weather.
            </li>
            <li>
              A Construction or Weather announcement can also be a News Item. A
              Transit announcement cannot be a New Item. (An announcement can be
              a News Item only.)
            </li>
            <li>
              Any announcement can also be High Priority Page (as appropriate).
            </li>
          </ul>
        </li>
        <li>
          The "Event ID" is the ID of a construction or special event associated
          with the announcemnet.
        </li>
        <li>
          Icons may be uploaded on the{" "}
          <span>
            <Link
              style={{ textDecoration: "none" }}
              className="hyper-links"
              onClick={(e) => {
                setOpenAdminWebFilesPage(true);
              }}
            >
              Admin Web File
            </Link>
          </span>{" "}
          page. Refresh this page to view newly uploaded icons and/or images.
        </li>
      </ul>
    </Typography>
  );
};

export default AnnouncementForm;
